/**
 * Fetch wrapper with a 30-second default timeout.
 * Only adds a timeout if no AbortSignal is already provided.
 */
export async function fetchWrapper(
  input: RequestInfo | URL,
  init?: RequestInit,
): Promise<Response> {
  if (!init?.signal) {
    return fetch(input, {
      ...init,
      signal: AbortSignal.timeout(30_000),
    });
  }
  return fetch(input, init);
}
